/** Retry pending rounds without overlapping calls or permanently suppressing failures. */
export function createSettlementRetryGate(delayMs = 5000, concurrency = 3) {
  const inFlight = new Set<number>();
  const nextAttempt = new Map<number, number>();
  return {
    start(round: number, now: number): boolean {
      if (inFlight.size >= concurrency || inFlight.has(round) || now < (nextAttempt.get(round) ?? 0)) return false;
      inFlight.add(round);
      return true;
    },
    finish(round: number, now: number) {
      inFlight.delete(round);
      nextAttempt.set(round, now + delayMs);
    },
  };
}
